import { Select, Textarea, Stack } from '@mantine/core';
import { REJECTION_REASON_OPTIONS } from '../../../../domain/entities/RejectionReason';
import type { RejectionReasonSelectProps } from './RejectionReasonSelect.types';

/**
 * Reusable component for selecting rejection reason and adding admin notes
 * Used across mention review, post review, and bulk rejection flows
 */
export function RejectionReasonSelect({
  rejectionReason,
  onRejectionReasonChange,
  adminNotes,
  onAdminNotesChange,
  disabled = false
}: RejectionReasonSelectProps): JSX.Element {
  return (
    <Stack gap="md">
      <Select
        label="Rejection Reason (Required)"
        placeholder="Select a reason"
        value={rejectionReason}
        onChange={(value): void => onRejectionReasonChange(value || '')}
        data={REJECTION_REASON_OPTIONS}
        required
        disabled={disabled}
      />
      <Textarea
        label="Admin Notes (Optional)"
        placeholder="Add any additional notes..."
        value={adminNotes}
        onChange={(e): void => onAdminNotesChange(e.currentTarget.value)}
        minRows={3}
        disabled={disabled}
      />
    </Stack>
  );
}
